import store from "@/store";
import pdfMakeParts from "@/plugins/pdfMakeParts";
const themeColor = '#000'//store.getters.getThemeColor

export default {
    // Function 1 Header
async generatePdfHeaderCompact_0(title, company, client, themeColor = '#1976d2', date = null) {
    let logoBase64 = null;
    try {
      const logoUrl = store.getters.getLogo;
      if (logoUrl) logoBase64 = await pdfMakeParts.getRoundedBase64Logo(logoUrl, 20);
    } catch (e) {
      console.warn('Logo load error:', e);
    }
  
    const compName = company?.name || 'Our Company';
    const compAddressStr = [company?.primary_address, company?.city, company?.postal_code].filter(Boolean).join(', ');
    const formattedDate = new Date(date || Date.now()).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  
    return {
      margin: [0, 0, 0, 10],
      columns: [
        {
          width: '*',
          stack: [
            logoBase64 ? { image: logoBase64, fit: [45, 45], margin: [0, 0, 0, 4] } : {},
            { text: compName.toUpperCase(), fontSize: 24, bold: true, color: '#000' },
            { text: compAddressStr, fontSize: 8, color: '#616161', margin: [0, 2, 0, 0] },
            { text: `${company?.email || ''} ${company?.primary_phone ? '• ' + company.primary_phone : ''}`, fontSize: 8, color: '#757575' }
          ]
        },
        {
          width: 'auto',
          alignment: 'right',
          stack: [
            { text: title.toUpperCase(), fontSize: 22, bold: true, color: themeColor },
            { text: `DATE: ${formattedDate}`, fontSize: 9, bold: true, color: '#424242', margin: [0, 4, 0, 0] },
            company?.vat_number ? { text: `VAT: ${company.vat_number}`, fontSize: 8, color: '#757575' } : {}
          ]
        }
      ]
    };
  },
  async generatePdfHeaderCompact_1(title, company, client, themeColor = '#1976d2', date = null) {
    let logoBase64 = null;
    try {
      const logoUrl = store.getters.getLogo;
      if (logoUrl) logoBase64 = await pdfMakeParts.getRoundedBase64Logo(logoUrl, 20);
    } catch (e) {
      console.warn('Logo load error:', e);
    }
  
    const compName = company?.name || 'Our Company';
    const tradingAs = company?.trading_as || compName;
    const compAddressStr = [company?.primary_address, company?.city, company?.postal_code].filter(Boolean).join(', ');
    const compPhone = company?.primary_phone ? `Phone: ${company.primary_phone}` : '';
    const compEmail = company?.email ? `Email: ${company.email}` : '';
    const compTax = company?.vat_number ? `VAT No: ${company.vat_number}` : (company?.reg_number ? `Reg No: ${company.reg_number}` : '');
  
    const formattedDate = new Date(date || Date.now()).toLocaleDateString(undefined, { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  
    return {
      stack: [
        // ==========================================
        // ROW 1: [Logo] (Left) | [Big Company Name] (Center) | [Title & Date] (Right)
        // ==========================================
        {
          columns: [
            // 1. Logo (Left)
            {
              width: '13%',
              stack: [
                logoBase64 
                  ? { image: logoBase64, fit: [50, 50], width: 50 } 
                  : { text: '' }
              ]
            },
            // 2. Large Centered Company Name
            {
              width: '63%',
              alignment: 'center',
              text: compName.toUpperCase(),
              fontSize: 27,
              bold: true,
              color: '#000'
            },
            // 3. Document Title & Date (Right)
            {
              width: '27%',
              alignment: 'right',
              stack: [
                { 
                  text: title.toUpperCase(), 
                  fontSize: 20, 
                  bold: true, 
                  color: themeColor, 
                  characterSpacing: 1 
                },
                {
                  text: [
                    { text: 'Date: ', bold: true, color: '#424242' },
                    { text: formattedDate }
                  ],
                  fontSize: 8.5,
                  color: '#616161',
                  margin: [0, 4, 0, 0]
                }
              ]
            }
          ]
        },
  
        // ==========================================
        // ROW 2: Company Address Details (Left side, directly under logo)
        // ==========================================
        {
          margin: [0, 8, 0, 0],
          columns: [
            {
              width: '65%',
              stack: [
                {
                    text: `${tradingAs}`,
                    fontSize: 12.5,
                },
                compAddressStr ? { text: compAddressStr, fontSize: 9.5, color: '#616161', margin: [0, 0, 0, 2] } : {},
                {
                  text: [
                    compPhone ? `${compPhone}   |   ` : '',
                    compEmail ? `${compEmail}` : ''
                  ],
                  fontSize: 9.5,
                  color: '#616161'
                },
                compTax ? { text: compTax, fontSize: 9, color: '#757575', margin: [0, 2, 0, 0] } : {}
              ]
            },
            {
              text: '',
              width: '35%' 
            }
          ]
        },
  
        // Divider Line
        {
          margin: [0, 8, 0, 0],
          canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5, lineColor: '#E2E8F0' }]
        }
      ]
    };
  },
  // Function 1 Subheader
  generateClientSubHeaderAuto_1(title, data) {
    const itsLegal = store.getters.getAppMode === 'legal';
    const isInvoice = title.toLowerCase().includes('invoice');
  
    return {
      margin: [0, 5, 0, 15],
      table: {
        widths: ['50%', '50%'],
        body: [
          [
            {
              fillColor: '#F8FAFC',
              margin: [8, 8, 8, 8],
              stack: [
                { text: 'PREPARED FOR', fontSize: 7, bold: true, color: '#94A3B8', margin: [0, 0, 0, 4] },
                { text: data?.clientName || data?.client?.name || 'N/A', fontSize: 10, bold: true, color: '#1E293B' },
                { text: data?.clientRef || data?.client?.client_reference || '', fontSize: 8.5, color: '#64748B' },
                { text: itsLegal ? (data?.internalRef || '') : `${data?.client?.address || ''}`, fontSize: 8.5, color: '#64748B' }
              ]
            },
            {
              fillColor: '#F8FAFC',
              margin: [8, 8, 8, 8,8],
              stack: [
                { text: 'VEHICLE & DOCUMENT DETAILS', fontSize: 7, bold: true, color: '#94A3B8', margin: [0, 0, 0, 4] },
                { text: `${isInvoice ? 'Invoice' : 'Quote'} #: ${data?.invoice_no || data?.invoice_number || 'N/A'}`, fontSize: 9.5, bold: true, color: '#1E293B' },
                { text: `Vehicle: ${data?.make || ''} ${data?.model || ''} (${data?.year || 'N/A'})`, fontSize: 8.5, color: '#64748B' },
                { text: `Plate: ${data?.license_plate || 'N/A'}  |  VIN: ${data?.vin || 'N/A'}`, fontSize: 8.5, color: '#64748B' },
                { text: `Issues Resolved: ${data?.customer_reported_issues || 'N/A'}`, fontSize: 8.5, color: store.getters.getThemeColor}
              ]
            }
          ]
        ]
      },
      layout: 'noBorders'
    };
  },

  // Function 2 Header
async generatePdfHeaderCompact_2(title, company, client, themeColor = '#1976d2', date = null) {
    let logoBase64 = null;
    try {
      const logoUrl = store.getters.getLogo;
      if (logoUrl) logoBase64 = await pdfMakeParts.getRoundedBase64Logo(logoUrl, 20);
    } catch (e) {
      console.warn('Logo load error:', e);
    }
  
    const compName = company?.name || 'Our Company';
    const formattedDate = new Date(date || Date.now()).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  
    return {
      margin: [-40, -40, -40, 15], // Full width bleeding to edges
      table: {
        widths: ['*'],
        body: [
          [
            {
              fillColor: themeColor,
              margin: [30, 15, 30, 15],
              columns: [
                {
                  width: '*',
                  columns: [
                    logoBase64 ? { image: logoBase64, fit: [40, 40], width: 48 } : {},
                    {
                      stack: [
                        { text: compName.toUpperCase(), fontSize: 16, bold: true, color: '#FFFFFF' },
                        { text: company?.email || '', fontSize: 8, color: '#E3F2FD' }
                      ]
                    }
                  ]
                },
                {
                  width: 'auto',
                  alignment: 'right',
                  stack: [
                    { text: title.toUpperCase(), fontSize: 20, bold: true, color: '#FFFFFF' },
                    { text: `Date: ${formattedDate}`, fontSize: 9, color: '#E3F2FD' }
                  ]
                }
              ]
            }
          ]
        ]
      },
      layout: 'noBorders'
    };
  },
  
  // Function 2 Subheader
  generateClientSubHeaderAuto_2(title, data) {
    const itsLegal = store.getters.getAppMode === 'legal';
    const isInvoice = title.toLowerCase().includes('invoice');
  
    return {
      margin: [0, 0, 0, 15],
      table: {
        widths: ['18%', '32%', '18%', '32%'],
        body: [
          [
            { text: 'Client Name', style: 'metaLabel', bold: true, fontSize: 8, color: '#616161' },
            { text: data?.clientName || data?.client?.name || '-', fontSize: 9 },
            { text: isInvoice ? 'Invoice No.' : 'Quote No.', bold: true, fontSize: 8, color: '#616161' },
            { text: data?.invoice_no || data?.invoice_number || '-', fontSize: 9, bold: true }
          ],
          [
            { text: 'Client Ref', bold: true, fontSize: 8, color: '#616161' },
            { text: data?.clientRef || data?.client?.client_reference || '-', fontSize: 8.5 },
            { text: itsLegal ? 'Internal Ref' : 'Address', bold: true, fontSize: 8, color: '#616161' },
            { text: itsLegal ? (data?.internalRef || 'N/A') : `${data?.client?.address || ''}`, fontSize: 8.5 }
          ],
          [
            { text: 'Vehicle Make', bold: true, fontSize: 8, color: '#616161' },
            { text: `${data?.make || '-'} (${data?.model || '-'})`, fontSize: 8.5 },
            { text: 'Plate / VIN', bold: true, fontSize: 8, color: '#616161' },
            { text: `${data?.license_plate || '-'} / ${data?.vin || '-'}`, fontSize: 8.5 }
          ]
        ]
      },
      layout: {
        hLineWidth: () => 0.5,
        vLineWidth: () => 0,
        hLineColor: () => '#CBD5E1',
        paddingTop: () => 5,
        paddingBottom: () => 5
      }
    };
  },

  // Function 3 Header
async generatePdfHeaderCompact_3(title, company, client, themeColor = '#1976d2', date = null) {
    let logoBase64 = null;
    try {
      const logoUrl = store.getters.getLogo;
      if (logoUrl) logoBase64 = await pdfMakeParts.getRoundedBase64Logo(logoUrl, 20);
    } catch (e) {
      console.warn('Logo load error:', e);
    }
  
    const compName = company?.name || 'Our Company';
    const formattedDate = new Date(date || Date.now()).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  
    return {
      margin: [0, 0, 0, 10],
      stack: [
        {
          columns: [
            logoBase64 ? { image: logoBase64, fit: [50, 50], width: 60 } : {},
            {
              width: '*',
              stack: [
                { text: compName, fontSize: 24, bold: true, color: '#1E293B' },
                { text: [company?.primary_phone, company?.email].filter(Boolean).join(' | '), fontSize: 8.5, color: '#64748B' }
              ]
            },
            {
              width: 'auto',
              alignment: 'right',
              stack: [
                { text: title.toUpperCase(), fontSize: 18, bold: true, color: themeColor },
                { text: `Issued: ${formattedDate}`, fontSize: 8.5, color: '#64748B', margin: [0, 2, 0, 0] }
              ]
            }
          ]
        },
        { canvas: [{ type: 'line', x1: 0, y1: 8, x2: 515, y2: 8, lineWidth: 1, lineColor: themeColor }] }
      ]
    };
  },
  
  // Function 3 Subheader
  generateClientSubHeaderAuto_3(title, data) {
    const itsLegal = store.getters.getAppMode === 'legal';
    const isInvoice = title.toLowerCase().includes('invoice');
  
    return {
      margin: [0, 10, 0, 15],
      columns: [
        {
          width: '48%',
          stack: [
            { text: 'CLIENT INFORMATION', fontSize: 7, bold: true, color: '#94A3B8', margin: [0, 0, 0, 2] },
            { text: data?.clientName || data?.client?.name || 'N/A', fontSize: 10, bold: true, color: '#0F172A' },
            { text: `Ref: ${data?.clientRef || data?.client?.client_reference || 'N/A'}`, fontSize: 8.5, color: '#475569' },
            { text: itsLegal ? `Internal: ${data?.internalRef || 'N/A'}` : `${data?.client?.address || ''}`, fontSize: 8.5, color: '#475569' }
          ]
        },
        { width: '4%', text: '' },
        {
          width: '48%',
          stack: [
            { text: 'REFERENCE DETAILS', fontSize: 7, bold: true, color: '#94A3B8', margin: [0, 0, 0, 2] },
            { text: `${isInvoice ? 'Invoice' : 'Quote'} #: ${data?.invoice_no || data?.invoice_number || 'N/A'}`, fontSize: 10, bold: true, color: '#0F172A' },
            { text: `Vehicle: ${data?.make || ''} ${data?.model || ''} (${data?.year || ''})`, fontSize: 8.5, color: '#475569' },
            { text: `Plate: ${data?.license_plate || 'N/A'} | VIN: ${data?.vin || 'N/A'}`, fontSize: 8.5, color: '#475569' }
          ]
        }
      ]
    };
  },
  // Function 4 Header
async generatePdfHeaderCompact_4(title, company, client, themeColor = '#1976d2', date = null) {
    let logoBase64 = null;
    try {
      const logoUrl = store.getters.getLogo;
      if (logoUrl) logoBase64 = await pdfMakeParts.getRoundedBase64Logo(logoUrl, 16);
    } catch (e) {
      console.warn('Logo load error:', e);
    }
  
    const compName = company?.name || 'Our Company';
    const formattedDate = new Date(date || Date.now()).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  
    return {
      margin: [0, 0, 0, 8],
      columns: [
        logoBase64 ? { image: logoBase64, fit: [30, 30], width: 36 } : {},
        {
          width: '*',
          stack: [
            { text: compName, fontSize: 14, bold: true, color: '#000000' },
            { text: `${company?.email || ''} | ${company?.primary_phone || ''}`, fontSize: 8, color: '#666666' }
          ]
        },
        {
          width: 'auto',
          alignment: 'right',
          stack: [
            { text: title.toUpperCase(), fontSize: 16, bold: true, color: themeColor },
            { text: formattedDate, fontSize: 8.5, color: '#666666' }
          ]
        }
      ]
    };
  },
  
  // Function 4 Subheader
  generateClientSubHeaderAuto_4(title, data) {
    const itsLegal = store.getters.getAppMode === 'legal';
    const isInvoice = title.toLowerCase().includes('invoice');
  
    return {
      margin: [0, 4, 0, 12],
      table: {
        widths: ['15%', '35%', '15%', '35%'],
        body: [
          [
            { text: 'Client:', fontSize: 8, bold: true },
            { text: data?.clientName || data?.client?.name || '-', fontSize: 8 },
            { text: isInvoice ? 'Invoice #:' : 'Quote #:', fontSize: 8, bold: true },
            { text: data?.invoice_no || data?.invoice_number || '-', fontSize: 8, bold: true }
          ],
          [
            { text: 'Client Ref:', fontSize: 8, bold: true },
            { text: data?.clientRef || data?.client?.client_reference || '-', fontSize: 8 },
            { text: itsLegal ? 'Int. Ref:' : 'Address:', fontSize: 8, bold: true },
            { text: itsLegal ? (data?.internalRef || '-') : `${data?.client?.address || '-'}`, fontSize: 8 }
          ],
          [
            { text: 'Vehicle:', fontSize: 8, bold: true },
            { text: `${data?.make || ''} ${data?.model || ''} ${data?.year || ''}`.trim() || '-', fontSize: 8 },
            { text: 'Plate / VIN:', fontSize: 8, bold: true },
            { text: `${data?.license_plate || '-'} / ${data?.vin || '-'}`, fontSize: 8 }
          ]
        ]
      },
      layout: 'lightHorizontalLines'
    };
  },
  // Function 5 Header
async generatePdfHeaderCompact_5(title, company, client, themeColor = '#1976d2', date = null) {
    let logoBase64 = null;
    try {
      const logoUrl = store.getters.getLogo;
      if (logoUrl) logoBase64 = await pdfMakeParts.getRoundedBase64Logo(logoUrl, 20);
    } catch (e) {
      console.warn('Logo load error:', e);
    }
  
    const compName = company?.name || 'Our Company';
    const formattedDate = new Date(date || Date.now()).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  
    return {
      margin: [0, 0, 0, 10],
      stack: [
        {
          columns: [
            {
              width: '60%',
              stack: [
                logoBase64 ? { image: logoBase64, fit: [45, 45], margin: [0, 0, 0, 4] } : {},
                { text: compName.toUpperCase(), fontSize: 15, bold: true, color: themeColor },
                { text: company?.primary_address || '', fontSize: 8.5, color: '#555555' },
                { text: `${company?.city || ''} ${company?.postal_code || ''}`, fontSize: 8.5, color: '#555555' }
              ]
            },
            {
              width: '40%',
              alignment: 'right',
              stack: [
                { text: title.toUpperCase(), fontSize: 20, bold: true, color: '#333333' },
                { text: `Date: ${formattedDate}`, fontSize: 9, margin: [0, 4, 0, 0] },
                company?.vat_number ? { text: `VAT Reg: ${company.vat_number}`, fontSize: 8, color: '#666666' } : {}
              ]
            }
          ]
        },
        {
          margin: [0, 8, 0, 0],
          canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1.5, lineColor: themeColor }]
        }
      ]
    };
  },
  
  // Function 5 Subheader
  generateClientSubHeaderAuto_5(title, data) {
    const itsLegal = store.getters.getAppMode === 'legal';
    const isInvoice = title.toLowerCase().includes('invoice');
  
    return {
      margin: [0, 10, 0, 15],
      table: {
        widths: ['16%', '34%', '16%', '34%'],
        body: [
          [
            { text: 'Client Name:', fontSize: 8.5, bold: true, color: '#333333' },
            { text: data?.clientName || data?.client?.name || '', fontSize: 8.5 },
            { text: isInvoice ? 'Invoice No:' : 'Quote No:', fontSize: 8.5, bold: true, color: themeColor || '#1976d2' },
            { text: data?.invoice_no || data?.invoice_number || '', fontSize: 8.5, bold: true }
          ],
          [
            { text: 'Client Ref:', fontSize: 8.5, bold: true, color: '#333333' },
            { text: data?.clientRef || data?.client?.client_reference || '', fontSize: 8.5 },
            { text: itsLegal ? 'Internal Ref:' : 'Address:', fontSize: 8.5, bold: true, color: '#333333' },
            { text: itsLegal ? (data?.internalRef || 'N/A') : `${data?.client?.address || ''}`, fontSize: 8.5 }
          ],
          [
            { text: 'Make / Model:', fontSize: 8.5, bold: true, color: '#333333' },
            { text: `${data?.make || ''} ${data?.model || ''}`, fontSize: 8.5 },
            { text: 'Licence Plate:', fontSize: 8.5, bold: true, color: '#333333' },
            { text: data?.license_plate || '', fontSize: 8.5 }
          ],
          [
            { text: 'Year & VIN:', fontSize: 8.5, bold: true, color: '#333333' },
            { text: `${data?.year || ''} / ${data?.vin || ''}`, fontSize: 8.5 },
            { text: '', fontSize: 8.5 },
            { text: '', fontSize: 8.5 }
          ]
        ]
      },
      layout: {
        hLineWidth: (i, node) => (i === 0 || i === node.table.body.length ? 0.5 : 0.5),
        vLineWidth: () => 0,
        hLineColor: () => '#E0E0E0',
        paddingLeft: () => 4,
        paddingRight: () => 4,
        paddingTop: () => 4,
        paddingBottom: () => 4
      }
    };
  }



}